import React from 'react';
import { useParams } from 'react-router-dom';
import HotelCard from '../components/HotelCard';

// TODO: Replace with real API fetch
const mockHotels = [
  {
    id: 1,
    name: 'Grand Palace Hotel',
    location: 'New York, USA',
    rating: 4.8,
    price: 299,
    images: [
      'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400',
      'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=400'
    ],
    amenities: ['Free WiFi', 'Pool', 'Spa', 'Restaurant', 'Gym'],
    description: 'Luxury hotel in the heart of Manhattan with stunning city views',
    rooms: [
      { type: 'Deluxe Suite', price: 399, capacity: 2, available: true },
      { type: 'Standard Room', price: 299, capacity: 2, available: false }
    ]
  }
  // ...more hotels
];

export default function HotelDetailsPage() {
  const { hotelId } = useParams();
  const hotel = mockHotels.find(h => String(h.id) === String(hotelId));

  if (!hotel) return <div style={{ padding: 32 }}>Hotel not found.</div>;

  return (
    <div style={{ maxWidth: 900, margin: '40px auto', padding: 32 }}>
      <h1 style={{ fontSize: 32, fontWeight: 700 }}>{hotel.name}</h1>
      <div style={{ display: 'flex', gap: 32, marginBottom: 24 }}>
        <img src={hotel.images[0]} alt={hotel.name} style={{ width: 340, borderRadius: 12 }} />
        <div>
          <div style={{ fontSize: 20, fontWeight: 500 }}>{hotel.location}</div>
          <div style={{ margin: '12px 0', color: '#2563eb', fontWeight: 600 }}>
            {hotel.rating} ★
          </div>
          <div style={{ marginBottom: 12 }}>{hotel.description}</div>
          <div style={{ marginBottom: 12 }}>
            <b>Amenities:</b> {hotel.amenities.join(', ')}
          </div>
        </div>
      </div>
      <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 16 }}>Rooms</h2>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 32 }}>
        <thead>
          <tr style={{ background: '#f3f4f6' }}>
            <th style={{ padding: 10, textAlign: 'left' }}>Type</th>
            <th style={{ padding: 10, textAlign: 'left' }}>Price</th>
            <th style={{ padding: 10, textAlign: 'left' }}>Capacity</th>
            <th style={{ padding: 10, textAlign: 'left' }}>Availability</th>
            <th style={{ padding: 10 }}></th>
          </tr>
        </thead>
        <tbody>
          {hotel.rooms.map((room, i) => (
            <tr key={i}>
              <td style={{ padding: 10 }}>{room.type}</td>
              <td style={{ padding: 10 }}>${room.price}</td>
              <td style={{ padding: 10 }}>{room.capacity}</td>
              <td style={{ padding: 10 }}>{room.available ? 'Available' : 'Booked'}</td>
              <td style={{ padding: 10 }}>
                <button
                  style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: 5, padding: '7px 18px', fontWeight: 600 }}
                  disabled={!room.available}
                >
                  Book Now
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
